module.exports = __webpack_public_path__ + "af4b61637c3c820ffe85283e5d56be79.png";